module.exports = new __parcel__URL__("legendary_pack.fecf913b.png").toString();